<script lang="ts">
import { Vue, Options } from "vue-class-component";

@Options({})
export default class AppBlocked extends Vue {

}
</script>

<template>
  <div class="p-4  text-center">
    <p class="font-medium text-lg">Приложение отключено</p>
    <p class="mt-2">Данное приложение было отключено. Свяжитесь с партнером для уточнения новой ссылки на
      приложение</p>
    <img src="@/assets/img/taxi-car.svg" class="w-5/6 mx-auto" alt="Taxi car">
  </div>
</template>